/**
 * The two catalogue facts migration 0176 added (plan-026, owner decisions 2026-10-21), read off the wire or raised:
 * a language pack's `maturity` (`general` | `beta`) and a voice's `gender` (`female` | `male` | `null`). Neither
 * defaults — a missing or unknown value on a documented response is a server defect (`./decode.ts`).
 */
import { LANGUAGE_MATURITY, VOICE_GENDER, type LanguageMaturity, type VoiceGender } from "./gateway.js";
import { MalformedResponseError } from "./decode.js";

export function languageMaturityOfWire(value: unknown, path: string): LanguageMaturity {
  const found = LANGUAGE_MATURITY.find((one) => one === value);
  if (found === undefined) throw new MalformedResponseError(path, `one of ${LANGUAGE_MATURITY.join(", ")}`, value);
  return found;
}

export function voiceGenderOfWire(value: unknown, path: string): VoiceGender | null {
  if (value === null) return null;
  const found = VOICE_GENDER.find((one) => one === value);
  if (found === undefined) throw new MalformedResponseError(path, `null or one of ${VOICE_GENDER.join(", ")}`, value);
  return found;
}
